export default {
    entityData: {
        entity: null,
        entityId: null,
        data: {},
    },

    fillableSettings: {},
};
